exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mylable{font-size:10px}", "", {"version":3,"sources":["/app/src/components/Staff.vue"],"names":[],"mappings":"AACA,SACE,cAAe,CAChB","file":"Staff.vue","sourcesContent":["\n.mylable{\n  font-size:10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51d7f40e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Staff.vue
// module id = 873
// module chunks = 10